var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnooker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4043 0C3.99296 0 0.404297 3.58867 0.404297 8C0.404297 12.4113 3.99296 16 8.4043 16C12.8156 16 16.4043 12.4113 16.4043 8C16.4043 3.58867 12.8156 0 8.4043 0ZM10.4043 4C10.4043 4.48 10.227 4.91533 9.9443 5.26067C10.427 5.68867 10.7376 6.306 10.7376 7C10.7376 8.28667 9.69096 9.33333 8.4043 9.33333C7.11763 9.33333 6.07096 8.28667 6.07096 7C6.07096 6.306 6.38163 5.68867 6.8643 5.26067C6.58096 4.91533 6.4043 4.48 6.4043 4C6.4043 2.89733 7.30163 2 8.4043 2C9.50696 2 10.4043 2.89733 10.4043 4ZM8.4043 14C5.0963 14 2.4043 11.3087 2.4043 8C2.4043 6.184 3.21496 4.55467 4.49363 3.45333C4.01563 4.18533 3.73763 5.06 3.73763 6C3.73763 8.57733 5.82696 10.6667 8.4043 10.6667C10.9816 10.6667 13.071 8.57733 13.071 6C13.071 5.06067 12.793 4.186 12.315 3.45333C13.593 4.55467 14.4043 6.184 14.4043 8C14.4043 11.3087 11.7123 14 8.4043 14ZM7.73763 4C7.73763 3.632 8.03696 3.33333 8.4043 3.33333C8.77163 3.33333 9.07096 3.632 9.07096 4C9.07096 4.368 8.77163 4.66667 8.4043 4.66667C8.03696 4.66667 7.73763 4.368 7.73763 4ZM7.4043 7C7.4043 6.44867 7.85296 6 8.4043 6C8.95563 6 9.4043 6.44867 9.4043 7C9.4043 7.55133 8.95563 8 8.4043 8C7.85296 8 7.4043 7.55133 7.4043 7Z",
    fill: "#38B000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnooker);
export default __webpack_public_path__ + "static/media/snooker.ef7c097a0623670d6780680a8d4a55bc.svg";
export { ForwardRef as ReactComponent };